export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}
